export const exchangeRates = {
  "USD": 1,
  "EUR": 0.87985093329795,
  "GBP": 0.73450700199059,
  "CAD": 1.2698383167071,
  "JPY": 115.05990179902,
  "AUD": 1.3892320834385,
  "CHF": 0.92072290045529,
  "MWK": 808.45386025666,
  "GTQ": 7.7392745709827,
  "KWD": 0.30314836447479,
  "CZK": 21.439723296941,
  "PGK": 3.5111065779074,
  "UAH": 28.265942045787,
  "ETB": 51.077220077221,
  "XCD": 2.7259427158459,
  "MMK": 1789.3146979261,
  "MVR": 15.557428459428,
  "SEK": 9.3335747794564,
  "MAD": 9.3935714654842,
  "RON": 4.3475087997087,
  "BYN": 2.5725356245269,
  "RSD": 104.63566570582,
  "GMD": 53.631081081083,
  "AWG": 1.8016615216996,
  "SLL": 11570.55393586,
  "KES": 114.37505403614,
  "BHD": 0.37749526073605,
  "OMR": 0.38563450243603,
  "RUB": 76.152817022385,
  "LYD": 4.5942825180297,
  "CLP": 796.93656650785,
  "BSD": 1.0052940878464,
  "DJF": 179.16572615232,
  "MZN": 64.531707317073,
  "UGX": 3540.3211418376,
  "BDT": 85.681810736362,
  "QAR": 3.6589343123353,
  "MXN": 20.293380048467,
  "AMD": 480.22641931647,
  "HTG": 102.56732909318,
  "FJD": 2.1561990655221,
  "CDF": 2015.5916708989,
  "SDG": 445.92134831462,
  "TOP": 2.3061770004068,
  "VUV": 113.97432583785,
  "HKD": 7.798745283396,
  "THB": 32.378643272596,
  "XAF": 577.99842044124,
  "MDL": 17.961792637666,
  "UYU": 43.211830335327,
  "LRD": 155.02734375,
  "LAK": 11503.47826087,
  "BWP": 11.560442761433,
  "JOD": 0.71014361797584,
  "BGN": 1.7201929132523,
  "VND": 22679.242315895,
  "UZS": 10800.540096605,
  "MGA": 4008.7878787878,
  "TTD": 6.8343378680903,
  "AOA": 529.15999999999,
  "KHR": 4091.4432989689,
  "NOK": 8.9113497970422,
  "LKR": 202.95696897418,
  "PLN": 3.9620041365406,
  "PEN": 3.7398443571328,
  "IQD": 1453.5516083382,
  "NIO": 35.689748201439,
  "CVE": 97.992592592591,
  "HNL": 24.7734082397,
  "SCR": 13.344653665097,
  "DOP": 56.784303999445,
  "NZD": 1.4921814200551,
  "HRK": 6.6242835332476,
  "DZD": 139.88308557561,
  "ARS": 106.96648770524,
  "STN": 21.878169790518,
  "XPF": 105.57018593887,
  "LSL": 15.147709923664,
  "TZS": 2329.0492957747,
  "BBD": 2.0001592060179,
  "ANG": 1.7974325744432,
  "PKR": 175.86062031829,
  "KRW": 1197.533015952,
  "AZN": 1.6937229731155,
  "CRC": 641.44678248905,
  "BND": 1.3522897642088,
  "KMF": 438.09471244068,
  "MRU": 36.577880184332,
  "MNT": 2892.638483965,
  "BRL": 5.170196791905,
  "EGP": 15.736655107857,
  "SGD": 1.3434876049496,
  "ZAR": 14.971148757071,
  "KGS": 84.616525461596,
  "PYG": 6964.3819143818,
  "JMD": 158.1155378486,
  "SSP": 435.21219431956,
  "GHS": 6.4406037000972,
  "CUP": 1.0052940878464,
  "DKK": 6.5430746836678,
  "INR": 75.042870268125,
  "TRY": 13.599495141737,
  "TWD": 27.872495995024,
  "TMT": 3.4893190325974,
  "AFN": 92.16674407803,
  "SRD": 20.584543568465,
  "ZMW": 18.039545454545,
  "YER": 251.83704549781,
  "LBP": 1502.7741416444,
  "HUF": 312.96173498065,
  "NGN": 417.16633698862,
  "IRR": 41811.474953212,
  "SVC": 8.8115008880995,
  "SBD": 8.0582741116752,
  "ALL": 107.2969611766,
  "MUR": 44.343016759777,
  "VES": 4.4544402211163,
  "NPR": 120.5251854543,
  "ISK": 124.54167087878,
  "GIP": 0.73870738653128,
  "GEL": 3.0288780977101,
  "MKD": 54.455268935236,
  "BIF": 2011.5053218449,
  "SZL": 15.147709923664,
  "SOS": 582.17691066451,
  "AED": 3.6611806534397,
  "PHP": 51.291726106389,
  "ILS": 3.1871342480973,
  "MRO": 36.370413511941,
  "COP": 3959.5910211226,
  "BZD": 2.0285728889798,
  "GNF": 9060.9589041098,
  "ERN": 15.170871559633,
  "WST": 2.6375357214062,
  "CNY": 6.3378620103284,
  "SAR": 3.7527113829009,
  "MYR": 4.1815063525545,
  "KZT": 428.78060847135,
  "PAB": 1.0026470439232,
  "GYD": 210.54111405835,
  "RWF": 1046.3221724229,
  "SYP": 2480.4375,
  "MOP": 8.0911314984709,
  "BAM": 1.7328297602934,
  "IDR": 14279.085907792,
  "TND": 2.8876513810311,
  "XOF": 577.89007974538,
  "TJS": 11.266057855192,
  "BOB": 6.8894665271965,
  "NAD": 15.159281894576
};
//end

export const currencyCodes: any = {
  BD: 'BDT',
  BE: 'EUR',
  BF: 'XOF',
  BG: 'BGN',
  BA: 'BAM',
  BB: 'BBD',
  WF: 'XPF',
  BL: 'EUR',
  BM: 'BMD',
  BN: 'BND',
  BO: 'BOB',
  BH: 'BHD',
  BI: 'BIF',
  BJ: 'XOF',
  BT: 'BTN',
  JM: 'JMD',
  BV: 'NOK',
  BW: 'BWP',
  WS: 'WST',
  BQ: 'USD',
  BR: 'BRL',
  BS: 'BSD',
  JE: 'GBP',
  BY: 'BYR',
  BZ: 'BZD',
  RU: 'RUB',
  RW: 'RWF',
  RS: 'RSD',
  TL: 'USD',
  RE: 'EUR',
  TM: 'TMT',
  TJ: 'TJS',
  RO: 'RON',
  TK: 'NZD',
  GW: 'XOF',
  GU: 'USD',
  GT: 'GTQ',
  GS: 'GBP',
  GR: 'EUR',
  GQ: 'XAF',
  GP: 'EUR',
  JP: 'JPY',
  GY: 'GYD',
  GG: 'GBP',
  GF: 'EUR',
  GE: 'GEL',
  GD: 'XCD',
  GB: 'GBP',
  GA: 'XAF',
  SV: 'USD',
  GN: 'GNF',
  GM: 'GMD',
  GL: 'DKK',
  GI: 'GIP',
  GH: 'GHS',
  OM: 'OMR',
  TN: 'TND',
  JO: 'JOD',
  HR: 'HRK',
  HT: 'HTG',
  HU: 'HUF',
  HK: 'HKD',
  HN: 'HNL',
  HM: 'AUD',
  VE: 'VEF',
  PR: 'USD',
  PS: 'ILS',
  PW: 'USD',
  PT: 'EUR',
  SJ: 'NOK',
  PY: 'PYG',
  IQ: 'IQD',
  PA: 'PAB',
  PF: 'XPF',
  PG: 'PGK',
  PE: 'PEN',
  PK: 'PKR',
  PH: 'PHP',
  PN: 'NZD',
  PL: 'PLN',
  PM: 'EUR',
  ZM: 'ZMK',
  EH: 'MAD',
  EE: 'EUR',
  EG: 'EGP',
  ZA: 'ZAR',
  EC: 'USD',
  IT: 'EUR',
  VN: 'VND',
  SB: 'SBD',
  ET: 'ETB',
  SO: 'SOS',
  ZW: 'ZWL',
  SA: 'SAR',
  ES: 'EUR',
  ER: 'ERN',
  ME: 'EUR',
  MD: 'MDL',
  MG: 'MGA',
  MF: 'EUR',
  MA: 'MAD',
  MC: 'EUR',
  UZ: 'UZS',
  MM: 'MMK',
  ML: 'XOF',
  MO: 'MOP',
  MN: 'MNT',
  MH: 'USD',
  MK: 'MKD',
  MU: 'MUR',
  MT: 'EUR',
  MW: 'MWK',
  MV: 'MVR',
  MQ: 'EUR',
  MP: 'USD',
  MS: 'XCD',
  MR: 'MRO',
  IM: 'GBP',
  UG: 'UGX',
  TZ: 'TZS',
  MY: 'MYR',
  MX: 'MXN',
  IL: 'ILS',
  FR: 'EUR',
  IO: 'USD',
  SH: 'SHP',
  FI: 'EUR',
  FJ: 'FJD',
  FK: 'FKP',
  FM: 'USD',
  FO: 'DKK',
  NI: 'NIO',
  NL: 'EUR',
  NO: 'NOK',
  NA: 'NAD',
  VU: 'VUV',
  NC: 'XPF',
  NE: 'XOF',
  NF: 'AUD',
  NG: 'NGN',
  NZ: 'NZD',
  NP: 'NPR',
  NR: 'AUD',
  NU: 'NZD',
  CK: 'NZD',
  XK: 'EUR',
  CI: 'XOF',
  CH: 'CHF',
  CO: 'COP',
  CN: 'CNY',
  CM: 'XAF',
  CL: 'CLP',
  CC: 'AUD',
  CA: 'CAD',
  CG: 'XAF',
  CF: 'XAF',
  CD: 'CDF',
  CZ: 'CZK',
  CY: 'EUR',
  CX: 'AUD',
  CR: 'CRC',
  CW: 'ANG',
  CV: 'CVE',
  CU: 'CUP',
  SZ: 'SZL',
  SY: 'SYP',
  SX: 'ANG',
  KG: 'KGS',
  KE: 'KES',
  SS: 'SSP',
  SR: 'SRD',
  KI: 'AUD',
  KH: 'KHR',
  KN: 'XCD',
  KM: 'KMF',
  ST: 'STD',
  SK: 'EUR',
  KR: 'KRW',
  SI: 'EUR',
  KP: 'KPW',
  KW: 'KWD',
  SN: 'XOF',
  SM: 'EUR',
  SL: 'SLL',
  SC: 'SCR',
  KZ: 'KZT',
  KY: 'KYD',
  SG: 'SGD',
  SE: 'SEK',
  SD: 'SDG',
  DO: 'DOP',
  DM: 'XCD',
  DJ: 'DJF',
  DK: 'DKK',
  VG: 'USD',
  DE: 'EUR',
  YE: 'YER',
  DZ: 'DZD',
  US: 'USD',
  UY: 'UYU',
  YT: 'EUR',
  UM: 'USD',
  LB: 'LBP',
  LC: 'XCD',
  LA: 'LAK',
  TV: 'AUD',
  TW: 'TWD',
  TT: 'TTD',
  TR: 'TRY',
  LK: 'LKR',
  LI: 'CHF',
  LV: 'EUR',
  TO: 'TOP',
  LT: 'LTL',
  LU: 'EUR',
  LR: 'LRD',
  LS: 'LSL',
  TH: 'THB',
  TF: 'EUR',
  TG: 'XOF',
  TD: 'XAF',
  TC: 'USD',
  LY: 'LYD',
  VA: 'EUR',
  VC: 'XCD',
  AE: 'AED',
  AD: 'EUR',
  AG: 'XCD',
  AF: 'AFN',
  AI: 'XCD',
  VI: 'USD',
  IS: 'ISK',
  IR: 'IRR',
  AM: 'AMD',
  AL: 'ALL',
  AO: 'AOA',
  AQ: '',
  AS: 'USD',
  AR: 'ARS',
  AU: 'AUD',
  AT: 'EUR',
  AW: 'AWG',
  IN: 'INR',
  AX: 'EUR',
  AZ: 'AZN',
  IE: 'EUR',
  ID: 'IDR',
  UA: 'UAH',
  QA: 'QAR',
  MZ: 'MZN',
};
export const countryCodes: any = {
  BD: '+880',
  BE: '+32',
  BF: '+226',
  BG: '+359',
  BA: '+387',
  BB: '+1-246',
  WF: '+681',
  BL: '+590',
  BM: '+1-441',
  BN: '+673',
  BO: '+591',
  BH: '+973',
  BI: '+257',
  BJ: '+229',
  BT: '+975',
  JM: '+1-876',
  BV: '+',
  BW: '+267',
  WS: '+685',
  BQ: '+599',
  BR: '+55',
  BS: '+1-242',
  JE: '+44-1534',
  BY: '+375',
  BZ: '+501',
  RU: '+7',
  RW: '+250',
  RS: '+381',
  TL: '+670',
  RE: '+262',
  TM: '+993',
  TJ: '+992',
  RO: '+40',
  TK: '+690',
  GW: '+245',
  GU: '+1-671',
  GT: '+502',
  GS: '+',
  GR: '+30',
  GQ: '+240',
  GP: '+590',
  JP: '+81',
  GY: '+592',
  GG: '+44-1481',
  GF: '+594',
  GE: '+995',
  GD: '+1-473',
  GB: '+44',
  GA: '+241',
  SV: '+503',
  GN: '+224',
  GM: '+220',
  GL: '+299',
  GI: '+350',
  GH: '+233',
  OM: '+968',
  TN: '+216',
  JO: '+962',
  HR: '+385',
  HT: '+509',
  HU: '+36',
  HK: '+852',
  HN: '+504',
  HM: '+ ',
  VE: '+58',
  PR: '+1-787 and 1-939',
  PS: '+970',
  PW: '+680',
  PT: '+351',
  SJ: '+47',
  PY: '+595',
  IQ: '+964',
  PA: '+507',
  PF: '+689',
  PG: '+675',
  PE: '+51',
  PK: '+92',
  PH: '+63',
  PN: '+870',
  PL: '+48',
  PM: '+508',
  ZM: '+260',
  EH: '+212',
  EE: '+372',
  EG: '+20',
  ZA: '+27',
  EC: '+593',
  IT: '+39',
  VN: '+84',
  SB: '+677',
  ET: '+251',
  SO: '+252',
  ZW: '+263',
  SA: '+966',
  ES: '+34',
  ER: '+291',
  ME: '+382',
  MD: '+373',
  MG: '+261',
  MF: '+590',
  MA: '+212',
  MC: '+377',
  UZ: '+998',
  MM: '+95',
  ML: '+223',
  MO: '+853',
  MN: '+976',
  MH: '+692',
  MK: '+389',
  MU: '+230',
  MT: '+356',
  MW: '+265',
  MV: '+960',
  MQ: '+596',
  MP: '+1-670',
  MS: '+1-664',
  MR: '+222',
  IM: '+44-1624',
  UG: '+256',
  TZ: '+255',
  MY: '+60',
  MX: '+52',
  IL: '+972',
  FR: '+33',
  IO: '+246',
  SH: '+290',
  FI: '+358',
  FJ: '+679',
  FK: '+500',
  FM: '+691',
  FO: '+298',
  NI: '+505',
  NL: '+31',
  NO: '+47',
  NA: '+264',
  VU: '+678',
  NC: '+687',
  NE: '+227',
  NF: '+672',
  NG: '+234',
  NZ: '+64',
  NP: '+977',
  NR: '+674',
  NU: '+683',
  CK: '+682',
  XK: '+',
  CI: '+225',
  CH: '+41',
  CO: '+57',
  CN: '+86',
  CM: '+237',
  CL: '+56',
  CC: '+61',
  CA: '+1',
  CG: '+242',
  CF: '+236',
  CD: '+243',
  CZ: '+420',
  CY: '+357',
  CX: '+61',
  CR: '+506',
  CW: '+599',
  CV: '+238',
  CU: '+53',
  SZ: '+268',
  SY: '+963',
  SX: '+599',
  KG: '+996',
  KE: '+254',
  SS: '+211',
  SR: '+597',
  KI: '+686',
  KH: '+855',
  KN: '+1-869',
  KM: '+269',
  ST: '+239',
  SK: '+421',
  KR: '+82',
  SI: '+386',
  KP: '+850',
  KW: '+965',
  SN: '+221',
  SM: '+378',
  SL: '+232',
  SC: '+248',
  KZ: '+7',
  KY: '+1-345',
  SG: '+65',
  SE: '+46',
  SD: '+249',
  DO: '+1-809 and 1-829',
  DM: '+1-767',
  DJ: '+253',
  DK: '+45',
  VG: '+1-284',
  DE: '+49',
  YE: '+967',
  DZ: '+213',
  US: '+1',
  UY: '+598',
  YT: '+262',
  UM: '+1',
  LB: '+961',
  LC: '+1-758',
  LA: '+856',
  TV: '+688',
  TW: '+886',
  TT: '+1-868',
  TR: '+90',
  LK: '+94',
  LI: '+423',
  LV: '+371',
  TO: '+676',
  LT: '+370',
  LU: '+352',
  LR: '+231',
  LS: '+266',
  TH: '+66',
  TF: '+',
  TG: '+228',
  TD: '+235',
  TC: '+1-649',
  LY: '+218',
  VA: '+379',
  VC: '+1-784',
  AE: '+971',
  AD: '+376',
  AG: '+1-268',
  AF: '+93',
  AI: '+1-264',
  VI: '+1-340',
  IS: '+354',
  IR: '+98',
  AM: '+374',
  AL: '+355',
  AO: '+244',
  AQ: '+',
  AS: '+1-684',
  AR: '+54',
  AU: '+61',
  AT: '+43',
  AW: '+297',
  IN: '+91',
  AX: '+358-18',
  AZ: '+994',
  IE: '+353',
  ID: '+62',
  UA: '+380',
  QA: '+974',
  MZ: '+258',
};

export const currencyInfo: any = {
  AED: {
    symbol: 'د.إ',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  AFN: {
    symbol: '؋',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  ALL: {
    symbol: 'L',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  AMD: {
    symbol: 'դր.',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  ANG: {
    symbol: 'ƒ',
    subunit_to_unit: 100,
    decimal_mark: ',',
    thousands_separator: '.',
    symbol_first: true,
  },
  AOA: {
    symbol: 'Kz',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  ARS: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: ',',
    thousands_separator: '.',
    symbol_first: true,
  },
  AUD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  AWG: {
    symbol: 'ƒ',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  AZN: {
    symbol: '₼',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  BAM: {
    symbol: 'КМ',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  BBD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  BDT: {
    symbol: '৳',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  BGN: {
    symbol: 'лв.',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  BHD: {
    symbol: 'د.ب',
    subunit_to_unit: 1000,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  BIF: {
    symbol: 'Fr',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  BMD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  BND: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  BOB: {
    symbol: 'Bs.',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  BRL: {
    symbol: 'R$',
    subunit_to_unit: 100,
    decimal_mark: ',',
    thousands_separator: '.',
    symbol_first: true,
  },
  BSD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  BTN: {
    symbol: 'Nu.',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  BWP: {
    symbol: 'P',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  BYN: {
    symbol: 'Br',
    subunit_to_unit: 100,
    decimal_mark: ',',
    thousands_separator: ' ',
    symbol_first: false,
  },
  BYR: {
    symbol: 'Br',
    subunit_to_unit: 1,
    decimal_mark: ',',
    thousands_separator: ' ',
    symbol_first: false,
  },
  BZD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  CAD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  CDF: {
    symbol: 'Fr',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  CHF: {
    symbol: 'CHF',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  CLF: {
    symbol: 'UF',
    subunit_to_unit: 10000,
    decimal_mark: ',',
    thousands_separator: '.',
    symbol_first: true,
  },
  CLP: {
    symbol: '$',
    subunit_to_unit: 1,
    decimal_mark: ',',
    thousands_separator: '.',
    symbol_first: true,
  },
  CNY: {
    symbol: '¥',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  COP: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: ',',
    thousands_separator: '.',
    symbol_first: true,
  },
  CRC: {
    symbol: '₡',
    subunit_to_unit: 100,
    decimal_mark: ',',
    thousands_separator: '.',
    symbol_first: true,
  },
  CUC: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  CUP: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  CVE: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  CZK: {
    symbol: 'Kč',
    subunit_to_unit: 100,
    decimal_mark: ',',
    thousands_separator: ' ',
    symbol_first: false,
  },
  DJF: {
    symbol: 'Fdj',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  DKK: {
    symbol: 'kr.',
    subunit_to_unit: 100,
    decimal_mark: ',',
    thousands_separator: '.',
    symbol_first: false,
  },
  DOP: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  DZD: {
    symbol: 'د.ج',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  EGP: {
    symbol: 'ج.م',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  ERN: {
    symbol: 'Nfk',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  ETB: {
    symbol: 'Br',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  EUR: {
    symbol: '€',
    subunit_to_unit: 100,
    decimal_mark: ',',
    thousands_separator: '.',
    symbol_first: true,
  },
  FJD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  FKP: {
    symbol: '£',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  GBP: {
    symbol: '£',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  GEL: {
    symbol: 'ლ',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  GHS: {
    symbol: '₵',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  GIP: {
    symbol: '£',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  GMD: {
    symbol: 'D',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  GNF: {
    symbol: 'Fr',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  GTQ: {
    symbol: 'Q',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  GYD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  HKD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  HNL: {
    symbol: 'L',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  HRK: {
    symbol: 'kn',
    subunit_to_unit: 100,
    decimal_mark: ',',
    thousands_separator: '.',
    symbol_first: false,
  },
  HTG: {
    symbol: 'G',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  HUF: {
    symbol: 'Ft',
    subunit_to_unit: 1,
    decimal_mark: ',',
    thousands_separator: ' ',
    symbol_first: false,
  },
  IDR: {
    symbol: 'Rp',
    subunit_to_unit: 100,
    decimal_mark: ',',
    thousands_separator: '.',
    symbol_first: true,
  },
  ILS: {
    symbol: '₪',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  INR: {
    symbol: '₹',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  IQD: {
    symbol: 'ع.د',
    subunit_to_unit: 1000,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  IRR: {
    symbol: '﷼',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  ISK: {
    symbol: 'kr.',
    subunit_to_unit: 1,
    decimal_mark: ',',
    thousands_separator: '.',
    symbol_first: false,
  },
  JMD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  JOD: {
    symbol: 'د.ا',
    subunit_to_unit: 1000,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  JPY: {
    symbol: '¥',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  KES: {
    symbol: 'KSh',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  KGS: {
    symbol: 'som',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  KHR: {
    symbol: '៛',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  KMF: {
    symbol: 'Fr',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  KPW: {
    symbol: '₩',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  KRW: {
    symbol: '₩',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  KWD: {
    symbol: 'د.ك',
    subunit_to_unit: 1000,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  KYD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  KZT: {
    symbol: '₸',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  LAK: {
    symbol: '₭',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  LBP: {
    symbol: 'ل.ل',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  LKR: {
    symbol: '₨',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  LRD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  LSL: {
    symbol: 'L',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  LYD: {
    symbol: 'ل.د',
    subunit_to_unit: 1000,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  MAD: {
    symbol: 'د.م.',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  MDL: {
    symbol: 'L',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  MGA: {
    symbol: 'Ar',
    subunit_to_unit: 5,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  MKD: {
    symbol: 'ден',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  MMK: {
    symbol: 'K',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  MNT: {
    symbol: '₮',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  MOP: {
    symbol: 'P',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  MRU: {
    symbol: 'UM',
    subunit_to_unit: 5,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  MUR: {
    symbol: '₨',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  MVR: {
    symbol: 'MVR',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  MWK: {
    symbol: 'MK',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  MXN: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  MYR: {
    symbol: 'RM',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  MZN: {
    symbol: 'MTn',
    subunit_to_unit: 100,
    decimal_mark: ',',
    thousands_separator: '.',
    symbol_first: true,
  },
  NAD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  NGN: {
    symbol: '₦',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  NIO: {
    symbol: 'C$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  NOK: {
    symbol: 'kr',
    subunit_to_unit: 100,
    decimal_mark: ',',
    thousands_separator: '.',
    symbol_first: false,
  },
  NPR: {
    symbol: 'Rs.',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  NZD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  OMR: {
    symbol: 'ر.ع.',
    subunit_to_unit: 1000,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  PAB: {
    symbol: 'B/.',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  PEN: {
    symbol: 'S/',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  PGK: {
    symbol: 'K',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  PHP: {
    symbol: '₱',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  PKR: {
    symbol: '₨',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  PLN: {
    symbol: 'zł',
    subunit_to_unit: 100,
    decimal_mark: ',',
    thousands_separator: ' ',
    symbol_first: false,
  },
  PYG: {
    symbol: '₲',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  QAR: {
    symbol: 'ر.ق',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  RON: {
    symbol: 'Lei',
    subunit_to_unit: 100,
    decimal_mark: ',',
    thousands_separator: '.',
    symbol_first: false,
  },
  RSD: {
    symbol: 'РСД',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  RUB: {
    symbol: '₽',
    subunit_to_unit: 100,
    decimal_mark: ',',
    thousands_separator: '.',
    symbol_first: false,
  },
  RWF: {
    symbol: 'FRw',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  SAR: {
    symbol: 'ر.س',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  SBD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  SCR: {
    symbol: '₨',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  SDG: {
    symbol: '£',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  SEK: {
    symbol: 'kr',
    subunit_to_unit: 100,
    decimal_mark: ',',
    thousands_separator: ' ',
    symbol_first: false,
  },
  SGD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  SHP: {
    symbol: '£',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  SKK: {
    symbol: 'Sk',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  SLL: {
    symbol: 'Le',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  SOS: {
    symbol: 'Sh',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  SRD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  SSP: {
    symbol: '£',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  STD: {
    symbol: 'Db',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  SVC: {
    symbol: '₡',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  SYP: {
    symbol: '£S',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  SZL: {
    symbol: 'E',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  THB: {
    symbol: '฿',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  TJS: {
    symbol: 'ЅМ',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  TMT: {
    symbol: 'T',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  TND: {
    symbol: 'د.ت',
    subunit_to_unit: 1000,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  TOP: {
    symbol: 'T$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  TRY: {
    symbol: '₺',
    subunit_to_unit: 100,
    decimal_mark: ',',
    thousands_separator: '.',
    symbol_first: true,
  },
  TTD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  TWD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  TZS: {
    symbol: 'Sh',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  UAH: {
    symbol: '₴',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  UGX: {
    symbol: 'USh',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  USD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  UYU: {
    symbol: '$U',
    subunit_to_unit: 100,
    decimal_mark: ',',
    thousands_separator: '.',
    symbol_first: true,
  },
  UZS: {
    symbol: "so'm",
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  VES: {
    symbol: 'Bs',
    subunit_to_unit: 100,
    decimal_mark: ',',
    thousands_separator: '.',
    symbol_first: true,
  },
  VND: {
    symbol: '₫',
    subunit_to_unit: 1,
    decimal_mark: ',',
    thousands_separator: '.',
    symbol_first: false,
  },
  VUV: {
    symbol: 'Vt',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  WST: {
    symbol: 'T',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  XAF: {
    symbol: 'CFA',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  XAG: {
    symbol: 'oz t',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  XAU: {
    symbol: 'oz t',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  XBA: {
    symbol: '',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  XBB: {
    symbol: '',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  XBC: {
    symbol: '',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  XBD: {
    symbol: '',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  XCD: {
    symbol: '$',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  XDR: {
    symbol: 'SDR',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  XOF: {
    symbol: 'Fr',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  XPD: {
    symbol: 'oz t',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  XPF: {
    symbol: 'Fr',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  XPT: {
    symbol: 'oz t',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  XTS: {
    symbol: '',
    subunit_to_unit: 1,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  YER: {
    symbol: '﷼',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  ZAR: {
    symbol: 'R',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
  ZMK: {
    symbol: 'ZK',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: false,
  },
  ZMW: {
    symbol: 'K',
    subunit_to_unit: 100,
    decimal_mark: '.',
    thousands_separator: ',',
    symbol_first: true,
  },
};
